var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeleconsulta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "120px",
    viewBox: "0 0 100 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "il-teleconsulta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 100,
    height: 120
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APP-benefici\\xE1rio-[SYMPTOM-CHECKER]",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resultado-|-Atendimento-por-video-[SYMPTOMCHECKER]",
    transform: "translate(-228.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "il-teleconsulta",
    transform: "translate(228.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ilustra",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    x: 17,
    y: 104,
    width: 46,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9775949,48 L22,47.5881306 C22.1131011,41.1092715 23.6373044,34.7471993 26.9690435,29.0540773 C29.1572139,25.3150401 29.1099394,21.2458468 28.5826129,17.8176307 C27.7688398,12.5272022 29.6611835,7.11431068 33.8661924,3.74657398 C37.0796749,1.16843609 41.1354496,-0.158692748 45.269619,0.0151497224 L46.1429738,0.0511390891 C51.9238316,0.288734248 57.1854105,3.41840389 60.107193,8.35727568 C61.5685941,10.9518811 62.1579447,13.9388426 61.7900683,16.8864657 C61.5049854,19.6599451 62.187135,22.4616749 63.7827513,25.2900878 C66.5355903,31.5008711 67.1317086,39.4483702 66.9775949,48 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D89379",
    fillRule: "nonzero",
    cx: 45,
    cy: 21,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,43 L36,41.8333305 C37.8620381,37.3721328 38.6058413,33.0761934 37.8627432,29 L52.0196075,29 C51.9875248,32.1297132 53.4795396,37.543538 55,43 Z",
    id: "Path",
    fill: "#D89379",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8FD16A",
    fillRule: "nonzero",
    points: "68 112.95214 25 116 29.4150401 40.3811933 36.9017819 38.285895 45.3481118 40.1905967 53.7944418 36 59.1694949 37.9051233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7403131,167 L3,160.355071 C11.5459932,131.712341 26.9420091,66.1861792 21.9723826,42.8347834 L37,36 L31.7403131,167 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8749979,85 L7,78.1504421 L16.2744555,50.5867597 C17.3088566,47.7425268 19.2901373,45.3544648 21.8757478,43.8354531 L25,42 L23.1249979,69.7787519 L17.8749979,85 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,161.776241 C83.8228798,167.092412 60.8831738,170.055855 50.8108527,166.343004 C50.0696873,140.405765 48.6161459,67.0390625 53.2813872,36 L70.0050123,42.8501433 L68.4846827,63.4005732 C60.4894288,80.9803477 83.7059133,142.210822 93,161.776241 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero",
    points: "90.8637507 81 80.6362493 77.5587737 67 61.8821704 69.2729179 42 92 74.1175475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0698193,95.6631401 C59.4139375,97.2773713 60.9150811,98.2895268 62.4260434,97.9260952 L71,95.8504017 L69.760826,90 L61.1866914,92.0752996 C59.675465,92.4413475 58.7278003,94.0475271 59.0698235,95.6631401 L59.0698193,95.6631401 Z",
    id: "Path",
    fill: "#D89379",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    fillRule: "evenodd",
    cx: 46,
    cy: 12,
    rx: 13,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,90 L71.8749979,99 C80.0746686,96.7130573 87.1809669,89.5033152 94,81 L92.1249979,75 L80.5,78 L67,90 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,71 L62.4285714,71 C62.4285714,49.5017942 57.8523994,34.52 53.3928593,34.52 L53,33 C56.9993438,33 59.5490918,39.2352935 60.983746,44.4662395 C62.9288525,51.5576576 64,60.9808374 64,71 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5172579,65 L27,65 C27,45.2617183 31.4489336,33 38,33 L37.6206876,34.5238095 C33.0893527,34.5238095 28.5172579,43.9473593 28.5172579,65 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 63,
    cy: 71,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5555556,75 L21,75 C21,69.4859882 24.1401629,65 28,65 L28,66.5384615 C24.9978858,66.5384615 22.5555556,70.3342856 22.5555556,75 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,75 L33.4444444,75 C33.4444444,70.3342915 31.0021142,66.5384723 28,66.5384723 L28,65 C31.8598371,65 35,69.4859952 35,75 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 33.5,
    cy: 74.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 21.5,
    cy: 74.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8FD16A",
    fillRule: "nonzero",
    points: "3 61 12.4350373 62.7186877 34 94 22.5433782 91.2499289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.786877278,60 C0.495349385,60.0044849 0.229363161,60.1709476 0.0929035545,60.4343108 C-0.0435560517,60.697674 -0.0288154784,61.0161084 0.131362578,61.2651249 L20.1993817,92.3877429 C20.3113643,92.5617335 20.484337,92.6852279 20.6827003,92.7328098 L30.0197542,94.9782724 C30.3420596,95.0558122 30.6777143,94.9217247 30.8631679,94.6413452 C31.0486216,94.3609657 31.0452952,93.9926201 30.8548096,93.7157876 L8.82135869,61.6930233 C8.70068155,61.5168214 8.51643278,61.3968757 8.3091907,61.3596026 L0.937385286,60.0138989 C0.887708794,60.0047861 0.837347262,60 0.786877278,60 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,81.9551234 L13.5622843,88 L22.435113,87.05995 C23.9990807,86.8942818 25.1410967,85.4067896 24.9858772,83.7375431 C24.8306577,82.0682966 23.4369812,80.8494055 21.8730135,81.0150735 L13,81.9551234 Z",
    id: "Path",
    fill: "#D89379",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,81.740354 C6.0272813,85.7542599 9.34696536,88.9953514 13.4356835,89 L14.9196574,89 L16,80.1614089 L7.05490396,77 L6,81.740354 Z",
    id: "Path",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleconsulta);
export default __webpack_public_path__ + "static/media/teleconsulta.43446487.svg";
export { ForwardRef as ReactComponent };